define('SageDotCom/Components/FunnelbackFacetsFilter',[
    "jquery",
    "underscore",
    "eventManager",
    "score_bootstrap/Utils/UrlHelper",
    "text!SageDotCom/Components/Templates/FacetSection.html",
    "text!SageDotCom/Components/Templates/AppliedFacetSection.html"
],
    function ($, _, eventManager, urlHelper, template, appliedTemplate) {
        function FunnelbackFacetsFilter(scope, searchStatsLabel, showAllLabel, showLessLabel, categoriesCount) {
            var appliedSections = []; // array which will contain applied facets objects
            var $facetsStatsDiv = $(".js-funnelback-search-stats", scope);
            var $resetFiltersDiv = $(".js-funnelback-reset-filters", scope);
            var $selectedFacetsCategoriesDiv = $(".js-funnelback-selected-facets-categories", scope);

            // convert underscore to mustache syntax
            _.templateSettings.interpolate = /\{\{(.+?)\}\}/g;

            eventManager.subscribe("display-funnelback-facets-filter", function (data) {
                appliedSections.length = 0; // empty the array
                $resetFiltersDiv.hide();
                $selectedFacetsCategoriesDiv.html("").hide(); // clear the selected facets div
                var currSearchStatsLabel = searchStatsLabel.replace("#", data.ResultsSummary.TotalMatching);
                $facetsStatsDiv.html(currSearchStatsLabel);

                var searchFacetsQueryString = getSearchFacets();

                // check if there are any facet with categories
                // otherwise we are hiding the whole component
                var hasFacetsWithCategories = _.find(data.Facets, function (facet) { return facet.Categories.length > 0; });

                if (hasFacetsWithCategories) {
                    $(".js-funnelback-facet-section", scope).each(function () {
                        var sectionKey = $(this).data("section-key");

                        // get the current section based on the section key
                        var currentSection = _.find(data.Facets, function (facet) {
                            return (facet.FacetKey.toLowerCase() == sectionKey.toLowerCase()) || (facet.Name.toLowerCase() == sectionKey.toLowerCase());
                        });

                        if (currentSection && currentSection.Categories.length > 0) {
                            currentSection.IsApplied = false;
                            currentSection.AppliedCategory = "";
                            currentSection.CategoriesLength = currentSection.Categories.length;
                            currentSection.CategoriesInitialCount = categoriesCount;

                            if (searchFacetsQueryString && currentSection.Categories && currentSection.CategoriesLength > 0) {
                                var facetQueryParam = currentSection.Categories[0].QueryParam.split(":")[0];
                                // it is applied if facets query string contains the facet query param
                                currentSection.IsApplied = searchFacetsQueryString.indexOf(facetQueryParam) !== -1;

                                // if this section is applied, get the name of the applied category and add it to appliedSections array
                                if (currentSection.IsApplied) {
                                    var facetsQueryStringParts = searchFacetsQueryString.split(","); // split facets query string by comma
                                    var currFacetsQueryStringPart = _.find(facetsQueryStringParts, function (part) { return part.indexOf(facetQueryParam) !== -1; }); // find the key-value pair of the current section
                                    currentSection.AppliedCategory = currFacetsQueryStringPart.split(":")[1]; // get the value

                                    $(this).parent().hide(); // hide this facet section because it will be show on top as an applied category

                                    // add the applied facet object to the array
                                    appliedSections.push({
                                        Name: currentSection.Name,
                                        AppliedCategory: currentSection.AppliedCategory,
                                        QueryString: currFacetsQueryStringPart
                                    });
                                }
                            }

                            // show facet categories for sections that are not applied
                            if (!currentSection.IsApplied) {
                                template = template.replace("#ShowAll#", showAllLabel);
                                var _template = _.template(template); // generate an underscore template
                                var html = _template(currentSection);

                                $(this).html(html);
                                $(this).parent().show();
                            }
                        } else {
                            $(this).parent().hide();
                        }
                    });

                    // if there are applied categories, show them within selected-facets-categories Div
                    if (appliedSections.length > 0) {
                        $resetFiltersDiv.show();

                        var appliedSectionsHtml = "";
                        $.each(appliedSections, function (index, section) {
                            var _appliedTemplate = _.template(appliedTemplate); // generate an underscore template
                            appliedSectionsHtml += _appliedTemplate(section);
                        });

                        $selectedFacetsCategoriesDiv.html(appliedSectionsHtml).show();
                    }

                    $(scope).show();
                } else {
                    // hide entire facets component if there are no facets
                    $(scope).hide();
                }

            });

            // when user selects a facet category, change query string and refresh the results
            $(document).on("click", ".js-funnelback-facets-list .js-funnelback-facet-section .js-category", function () {
                var currentSearchFacetsQueryString = getSearchFacets();

                // build search facets query string by adding the selected category to the existing search facets query string
                var searchFacets = $(this).data("query-param") + (currentSearchFacetsQueryString ? "," + currentSearchFacetsQueryString : "");
                urlHelper.setUrlParameters(window.location, "searchfacets", searchFacets);
                urlHelper.setUrlParameters(window.location, "searchstartrank", 1); // reset the pagination

                eventManager.trigger("refresh-funnelback-search-results");
                eventManager.trigger("funnelback-facet-refinement", scope);

                return false;
            });

            // when user clicks on 'show more' link, show the rest of categories
            $(document).on("click", ".js-funnelback-facets-list .js-funnelback-facet-section .js-show-all", function () {
                $(this).siblings(".js-category").show();
                $(this).removeClass("show-all").addClass("show-less");
                $(this).removeClass("js-show-all").addClass("js-show-less");
                $(this).text(showLessLabel);

                return false;
            });

            // when user clicks on 'show less' link, hide categories
            $(document).on("click", ".js-funnelback-facets-list .js-funnelback-facet-section .js-show-less", function () {
                $(this).siblings(".js-category:gt(" + (categoriesCount - 1) + ")").hide();
                $(this).removeClass("show-less").addClass("show-all");
                $(this).removeClass("js-show-less").addClass("js-show-all");
                $(this).text(showAllLabel);

                return false;
            });

            // reset the applied category when user clicks on it
            $(document).on("click", ".js-funnelback-selected-facets-categories .js-funnelback-facet-section", function (event) {
                event.preventDefault();
                var currentSearchFacetsQueryString = getSearchFacets();
                var appliedCategoryQueryString = $(this).data("applied-category-query-string");

                if (appliedCategoryQueryString) {
                    // build search facets query string by removing the applied category from the existing search facets query string
                    // remove comma from the beginning/end of facets query string value
                    var searchFacets = currentSearchFacetsQueryString.replace(appliedCategoryQueryString, "");
                    if (searchFacets.startsWith(",")) {
                        searchFacets = searchFacets.substr(1);
                    }
                    if (searchFacets.endsWith(",")) {
                        searchFacets = searchFacets.substr(0, searchFacets.length - 1);
                    }
                    urlHelper.setUrlParameters(window.location, "searchfacets", searchFacets);
                    urlHelper.setUrlParameters(window.location, "searchstartrank", 1); // reset the pagination

                    eventManager.trigger("refresh-funnelback-search-results");
                    eventManager.trigger("funnelback-facet-refinement", scope);
                }
            });

            // reset all filters
            $(".js-funnelback-reset-filters", scope).click(function (event) {
                event.preventDefault();

                urlHelper.setUrlParameters(window.location, "searchfacets", ""); // clear the facets query string
                urlHelper.setUrlParameters(window.location, "searchstartrank", 1); // reset the pagination

                eventManager.trigger("refresh-funnelback-search-results");
                eventManager.trigger("funnelback-facet-refinement", scope);
            });

            // getting the facets value from query string
            function getSearchFacets() {
                const regex = new RegExp("<(\"[^\"]*\"|'[^']*'|[^'\">])*>");
                var searchFacets = urlHelper.getUrlParameters(window.location, "searchfacets");

                if (searchFacets && searchFacets.length > 0) {
                    var searchFacet = searchFacets[0];
                    var searchFacetDecoded = decodeURI(searchFacet);
                    if (regex.test(searchFacetDecoded) || searchFacetDecoded.indexOf("=") > -1 || searchFacetDecoded.indexOf("\"") > -1) {
                        urlHelper.setUrlParameters(window.location, "searchfacets", ""); //Detected HTML or markup allowing scripts, clear the query param
                        return "";
                    }
                    return searchFacet;
                } else {
                    return "";
                }
            }
        }

        return function initFunnelbackFacetsFilter(args) {
            return args.IsExperienceEditorEditing === false
                ? new FunnelbackFacetsFilter(args.scope, args.SearchStatsLabel, args.ShowAllLabel, args.ShowLessLabel, args.CategoriesCount)
                : null;
        };
    });
